import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { IUProperty } from "../../shared/interface/umbraco-property";
import { IPictureData } from "../../shared/components/picture/picture.component";
import { IOnboardingPanelCard } from "./components/onboarding-panel-card/onboarding-panel-card.component";
import { SimplebarAngularComponent } from "simplebar-angular";
import { MqService } from "src/app/service/mq.service";
import { applySubtitleSettings, applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ISubtitleStyleSettings, ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { placementToAlign } from "../../shared/utils/placement-to-alignment";

interface IOnboardingPanelData {
  title?: IUProperty<string>;
  subtitle?: IUProperty<string>;
  items: IUProperty<IOnboardingPanelCard[]>;
  backgroundImage?: IUProperty<IPictureData>;

  itemTitleSize?: IUProperty<string>;
  itemTitleFontWeight?: IUProperty<string>;
  itemPriceSize?: IUProperty<string>;
  itemPriceFontWeight?: IUProperty<string>;
  itemPriceDescSize?: IUProperty<string>;
  itemPriceDescFontWeight?: IUProperty<string>;
  itemInfoSize?: IUProperty<string>;
  itemInfoFontWeight?: IUProperty<string>;

  titleStyleSettings?: ITitleStyleSettings;
  subtitleStyleSettingsComposition?: ISubtitleStyleSettings;
}

@Component({
  selector: "app-onboarding-panel",
  templateUrl: "./onboarding-panel.component.html",
  styleUrls: ["./onboarding-panel.component.less"],
})
export class OnboardingPanelComponent implements AfterViewInit {
  @Input() data: IOnboardingPanelData;

  @ViewChild("panelEl", { static: false }) panelElRef: ElementRef<HTMLElement>;
  @ViewChild("titleEl", { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild("wrapperEl", { static: false }) wrapperEl: ElementRef<HTMLElement>;
  @ViewChild("subtitleEl", { static: false }) subtitleEl: ElementRef<HTMLElement>;
  @ViewChild('scrollEl', { static: false }) scrollEl: SimplebarAngularComponent;

  scrollBarOptions = { autoHide: false, scrollbarMinSize: 100 };

  constructor(private hostRef: ElementRef, private mq: MqService) {}

  ngAfterViewInit(): void {
    applyTitleSettings(this.data, this.titleEl);
    applySubtitleSettings(this.data, this.subtitleEl);
    this.applyCustomItemThemes(this.data);

    if (
      this.panelElRef &&
      this.panelElRef.nativeElement &&
      this.data &&
      this.data.backgroundImage &&
      this.data.backgroundImage.value
    ) {
      this.panelElRef.nativeElement.style.backgroundImage =
        "url(" + this.data.backgroundImage.value.src + ")";
      this.panelElRef.nativeElement.style.backgroundSize = "cover";
      this.panelElRef.nativeElement.style.backgroundRepeat = "no-repeat";
    }

    if (this.mq.isMidi()) {
      this.scrollToFocusedItem();
    }
  }

  applyCustomItemThemes(d: IOnboardingPanelData) {
    if (!d || !this.wrapperEl) return;
    const scrollElStyle = this.wrapperEl.nativeElement.style

    if (d.itemTitleSize && d.itemTitleSize.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-title-size", d.itemTitleSize.value + 'px');
    }
    if (d.itemTitleFontWeight && d.itemTitleFontWeight.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-title-font-weight", d.itemTitleFontWeight.value);
    }

    if (d.itemPriceSize && d.itemPriceSize.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-price-size", d.itemPriceSize.value + 'px');
    }
    if (d.itemPriceFontWeight && d.itemPriceFontWeight.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-price-font-weight", d.itemPriceFontWeight.value);
    }

    if (d.itemPriceDescSize && d.itemPriceDescSize.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-priceDesc-size", d.itemPriceDescSize.value + 'px');
    }
    if (d.itemPriceDescFontWeight && d.itemPriceDescFontWeight.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-priceDesc-font-weight", d.itemPriceDescFontWeight.value);
    }

    if (d.itemInfoSize && d.itemInfoSize.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-info-size", d.itemInfoSize.value + 'px');
    }
    if (d.itemInfoFontWeight && d.itemInfoFontWeight.value) {
      scrollElStyle.setProperty("--onboarding-panel-item-info-font-weight", d.itemInfoFontWeight.value);
    }
  }

  private scrollToFocusedItem() {
    const focusedItem = document.querySelector(".focused-onboarding");

    if (focusedItem) {
      const middleScreenWidth = window.screen.width / 2;
      const focusedItemRects = focusedItem.getClientRects()[0];
      const scrollContainer = this.scrollEl.SimpleBar.contentWrapperEl;

      scrollContainer.scrollTo({
        left:
          focusedItemRects.left -
          middleScreenWidth +
          focusedItemRects.width / 2,
        behavior: "smooth",
      });
    }
  }
}
